"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var validate = exports.validate = function validate(value, settings) {
  var ids = settings.items.map(function (item) {
    return item.id;
  });
  var visited = (0, _get2["default"])(value, 'visited', []);
  if (settings.completeCondition === 'all' && (0, _difference2["default"])(ids, visited).length > 0) {
    return settings.completeAllErrorMessage;
  }
  if (settings.completeCondition === 'minimum' && (0, _intersection2["default"])(ids, visited).length < settings.minimumNumber) {
    return settings.completeMinErrorMessage.replace(':min', settings.minimumNumber);
  }
};